module.exports = __webpack_public_path__ + "media/images/page/kodawari03-46dbce99ff3a8cc757f5fd3d4ed7d395.jpg";